import { render, staticRenderFns } from "./dataBox4.vue?vue&type=template&id=b6a28d54&scoped=true&"
import script from "./dataBox4.vue?vue&type=script&lang=ts&"
export * from "./dataBox4.vue?vue&type=script&lang=ts&"
import style0 from "./dataBox4.vue?vue&type=style&index=0&id=b6a28d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a28d54",
  null
  
)

export default component.exports